import { getTvObject, tv } from '@costar-ui/cosmos';

var bannerTV = getTvObject({
  base: ['bg-base', 'p-4', 'border', 'border-l-4', 'border-neutral', 'gap-4', 'min-h-14', 'w-full'],
  variants: {
    variant: {
      neutral: 'border-neutral',
      negative: 'border-status-negative',
      caution: 'border-status-caution',
      informative: 'border-status-informative'
    }
  }
});
var base = tv(bannerTV);
var bannerStyles = {
  base: base
};

export { bannerStyles, bannerTV };
//# sourceMappingURL=banner.styles.esm.js.map
